import cplook from 'cplook'
import Pluralize from 'pluralize'

# EDIT JOB SAVE BUTTON - HANDLES CONDITIONAL FLOW OF OPERATIONS THAT TAKE PLACE UPON PRESSING SAVE

$( ->
  $(document).on 'click', '.job-save-trigger', ->
    form = $($(this).data('form-id'))
    nextPostAction(form)
    return false
)

mobile = $(window).width() < cplook.mobilePivot

flaggedContentMessages = (form) ->
  return [] if !$('#job_name') || !tinyMCE.get('job_description')

  titleText = $('#job_name').val().trim()
  bodyText = tinyMCE.get('job_description').getContent()

  flaggedPhrases = $(form).data().flaggedPhrases
  errorMessages = []

  pluralizeMessage = pluralizeWarning(titleText, "Job title")
  errorMessages.push(pluralizeMessage) if pluralizeMessage?

  titleCharsMessage = titleCharsWarning(titleText, "Job title")
  errorMessages.push(titleCharsMessage) if titleCharsMessage?

  return errorMessages if !flaggedPhrases

  for phrase in flaggedPhrases
    do (phrase) ->
      titleMatch = compareStrings(titleText, phrase, "Job title")
      bodyMatch = compareStrings(bodyText, phrase, "Job description")
      errorMessages.push(titleMatch) if titleMatch?
      errorMessages.push(bodyMatch) if bodyMatch?

  errorMessages

pluralizeWarning = (text, textTitle) ->
  return null unless !!text
  words = text.split(/\s/)
  [..., last] = words
  result = Pluralize(last) == last
  if result == true
    return "<b>#{textTitle} may be plural</b>. Job quality guidelines on our job partner sites require each job posting to be for a single open position."
  else
    return null

titleCharsWarning = (text, textTitle) ->
  return null unless !!text
  words = text.split(/\s/)
  result = hasNonAlphaChars(words)
  if result == true
    return "<b>#{textTitle} contains characters other than letters</b>. Titles that include numbers, certain punctuation marks, or other special characters may cause your job to be flagged for removal from some job boards. Allowed special characters include forward slash (/), single quote ('), and an ampersand (&)."
  else
    return null

compareStrings = (text, phrase, textTitle) ->
  rgxp = new RegExp(phrase, "gim")
  result = text.match(rgxp)
  if result?
    return "<b>#{textTitle} contains the following phrase: #{result[0]}</b>. We recommend removing this phrase."
  else
    return null

hasNonAlphaChars = (words) ->
  result = false
  words.forEach (word) ->
    chars = word.match(/[^A-Za-z\s\'\&\/]/)
    result = true if chars && chars.length > 0
  return result

needsInactivateAppsPrompt = (activeApps, currentStatus) ->
  return false unless (currentStatus == 1) || (currentStatus == 3)
  return false unless activeApps > 0

  selectedStatus =
    if !!mobile
      +($("#job_status").val())
    else
      +($("input[name='job[status]']:checked").val())

  return selectedStatus == 2


showAction = (action, form, ignored) ->
  condition = false
  if action == 'flaggedWarningModal'
    errorMessages = flaggedContentMessages(form)
    flaggedWarningIgnored = $(form).attr('data-ignore-flag-warnings') == 'true'
    condition = errorMessages.length > 0 && !flaggedWarningIgnored

  else if action == 'approvalCommentModal'
    needsApproval = $(form).attr('data-needs-approval') == 'true'
    condition = needsApproval

  else if action == 'inactivateAppsModal'
    activeApps = +($(form).attr('data-active-apps'))
    currentStatus = +($(form).attr('data-current-status'))
    condition = needsInactivateAppsPrompt(activeApps, currentStatus)

  else if action == 'createTemplateModal'
    createTemplate = $(form).attr('data-create-template') == 'true'
    condition = createTemplate

  else if action == 'copyTemplateModal'
    copyTemplateChanges = $(form).attr('data-copy-changes') == 'true'
    condition = copyTemplateChanges

  return condition && !(action in ignored)


nextPostAction = (form, ignored = []) ->
  if showAction('flaggedWarningModal', form, ignored)
    errorMessages = flaggedContentMessages(form)
    succeeded = flaggedWarningModal(form, errorMessages)
  else if showAction('approvalCommentModal', form, ignored)
    succeeded = approvalCommentModal()
  else if showAction('inactivateAppsModal', form, ignored)
    succeeded = inactivateAppsModal()
  else if showAction('createTemplateModal', form, ignored)
    succeeded = createTemplateModal()
  else if showAction('copyTemplateModal', form, ignored)
    succeeded = copyTemplateModal()
  else
    succeeded = submitForm(form)

  submitForm(form) unless succeeded


flaggedWarningModal = (form, errorMessages) ->
  return false unless $("#job_flag_warning_modal").length > 0
  $("#job_flag_warning_modal .flagged_error_messages").html("<ul></ul>")
  for msg in errorMessages
    do (msg) ->
      $("<li>#{msg}</li>").appendTo("#job_flag_warning_modal .flagged_error_messages ul")

  $("#job_flag_warning_modal #discard-warning").prop('checked', false)
  $("#job_flag_warning_modal .next-post-action").attr('disabled', true)

  $("#job_flag_warning_modal #discard-warning").change ->
    discardWarning = $(this).is(":checked")
    $("#job_flag_warning_modal .next-post-action").attr('disabled', !discardWarning)

  $(document).on 'click', "#job_flag_warning_modal .next-post-action", ->
    $(form).attr('data-ignore-flag-warnings', true)
    nextPostAction(form)

  $("#job_flag_warning_modal").modal('show')
  true

approvalCommentModal = ->
  return false unless $("#job_approval_comment").length > 0
  $("#job_approval_comment").modal('show')
  true

createTemplateModal = ->
  return false unless $("#job_template_prompt").length > 0
  $(document).on 'click', '#job_template_prompt .btn.yes:not(.submit-form)', ->
    form = $(this).closest('form')
    $(form).append('<input type="hidden" name="job[copy_to_template]" value="t" />')
    $(this).addClass("submit-form")
    $(this).click()

  $("#job_template_prompt").modal('show')
  true

inactivateAppsModal = ->
  return false unless $("#inactivate_apps_from_job").length > 0

  $(document).on 'click', "#inactivate_apps_from_job .next-post-action", ->
    form = $(this).closest('form')
    nextPostAction(form, ['inactivateAppsModal'])

  $("#inactivate_apps_from_job").modal('show')
  true

copyTemplateModal = ->
  return false unless $("#apply_changes").length > 0
  $("#apply_changes").modal('show')
  true

submitForm = (form) ->
  $(form).submit()
  true
